import { CommonHelperFunctions, IColumnTypes, IDataDiagramSchemeDto } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export class DataDiagramSchemeService {
  public static async GetSchema(): Promise<AxiosResponse<IDataDiagramSchemeDto>> {
    try {
      const res = await Axios.get<null, AxiosResponse>(`${backendUrl}/typesystem/schema`);
      return res;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetLatestTypeSystemModelDiagram(): Promise<AxiosResponse<string>> {
    try {
      const res = await Axios.get<null, AxiosResponse>(`${backendUrl}/typesystem/diagram`);
      return res;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async ExecuteMigrationScript(scheme: IDataDiagramSchemeDto): Promise<AxiosResponse> {
    try {
      return await Axios.post<IDataDiagramSchemeDto, AxiosResponse>(`${backendUrl}/typesystem/execmigration`, scheme);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetLatestTypeSystemSchemaAndDiagram(): Promise<AxiosResponse> {
    try {
      return await Axios.get<null, AxiosResponse>(`${backendUrl}/typesystem/getlatesttypesystemschemaanddiagram`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async GetColumnTypes(): Promise<AxiosResponse<IColumnTypes[]>> {
    try {
      const res = await Axios.get<null, AxiosResponse>(`${backendUrl}/typesystem/columntypes`);
      return res;
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  public static async CheckSchemaReservedKeyUsed(schema: any): Promise<AxiosResponse> {
    try {
      const res = await Axios.post<null, AxiosResponse>(`${backendUrl}/typesystem/checkschemareservedkeyused`, schema);
      return res;
    } catch (error: any) {
      KMainFunctions.warningHandler(error);
      return error;
    }
  }

  public static async CreateSchemaFromExcel(obj: any): Promise<AxiosResponse> {
    try {
      return await Axios.post<IDataDiagramSchemeDto, AxiosResponse>(`${backendUrl}/typesystem/fromexcel`, obj);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
